import { useEffect, useState } from "react";

async function api(path, options) {
  return fetch(path, { credentials: "same-origin", headers: { "Content-Type": "application/json" }, ...options });
}

export function ContactInbox({ chapterId, canManage }) {
  const [messages, setMessages] = useState(null);

  function load() {
    api(`/api/chapters/${chapterId}/messages`)
      .then((res) => (res.ok ? res.json() : { messages: [] }))
      .then((data) => setMessages(data.messages));
  }
  useEffect(load, [chapterId]);

  async function toggle(m) {
    await api(`/api/messages/${m.id}`, { method: "PATCH", body: JSON.stringify({ handled: !m.handled }) });
    load();
  }
  async function remove(m) {
    if (!window.confirm("Delete this message?")) return;
    await api(`/api/messages/${m.id}`, { method: "DELETE" });
    load();
  }

  if (messages === null) return <p className="muted">Loading…</p>;

  return (
    <>
      <div className="section-head"><h3>Messages · {messages.length}</h3></div>
      {messages.length ? (
        <table className="tbl">
          <thead>
            <tr><th>Received</th><th>From</th><th>Type</th><th>Message</th>{canManage && <th />}</tr>
          </thead>
          <tbody>
            {messages.map((m) => (
              <tr key={m.id} style={m.handled ? { opacity: 0.55 } : {}}>
                <td className="muted">{m.received_at.slice(0, 16).replace("T", " ")}</td>
                <td>
                  <strong>{m.name}</strong><br />
                  <a href={`mailto:${m.email}`} className="muted" style={{ fontSize: 12 }}>{m.email}</a>
                </td>
                <td>{m.inquiry_type || "—"}</td>
                <td style={{ maxWidth: 360, whiteSpace: "pre-wrap" }}>{m.message}</td>
                {canManage && (
                  <td className="row-actions">
                    <button className="btn-ghost" type="button" onClick={() => toggle(m)}>
                      {m.handled ? "Reopen" : "Mark done"}
                    </button>
                    <button className="btn-danger" type="button" onClick={() => remove(m)}>Delete</button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="empty">No messages yet.</p>
      )}
    </>
  );
}
